/**
 * SecurityMetricCard Component
 * Displays a security metric with click navigation to filtered audit view
 */

import { Link } from 'react-router-dom';

interface SecurityMetricCardProps {
  title: string;
  value: number;
  description?: string;
  icon: string;
  color: 'green' | 'red' | 'yellow' | 'blue' | 'gray';
  linkTo?: string;
}

const colorClasses = {
  green: 'bg-green-50 text-green-600 border-green-200',
  red: 'bg-red-50 text-red-600 border-red-200',
  yellow: 'bg-yellow-50 text-yellow-600 border-yellow-200',
  blue: 'bg-blue-50 text-blue-600 border-blue-200',
  gray: 'bg-gray-50 text-gray-600 border-gray-200',
};

const iconBgClasses = {
  green: 'bg-green-100',
  red: 'bg-red-100',
  yellow: 'bg-yellow-100',
  blue: 'bg-blue-100',
  gray: 'bg-gray-100',
};

export function SecurityMetricCard({
  title,
  value,
  description,
  icon,
  color,
  linkTo,
}: SecurityMetricCardProps) {
  const content = (
    <div className={`rounded-lg border p-4 ${colorClasses[color]} ${linkTo ? 'hover:shadow-md transition-shadow cursor-pointer' : ''}`}>
      <div className="flex items-start justify-between">
        <div>
          <p className="text-sm font-medium text-gray-600">{title}</p>
          <p className="mt-2 text-3xl font-bold">{value.toLocaleString()}</p>
          {description && (
            <p className="mt-1 text-xs text-gray-500">{description}</p>
          )}
        </div>
        <div className={`rounded-full p-2 ${iconBgClasses[color]}`}>
          <span className="text-2xl">{icon}</span>
        </div>
      </div>
      {linkTo && (
        <p className="mt-3 text-xs text-gray-500 flex items-center gap-1">
          Ver detalles
          <span>→</span>
        </p>
      )}
    </div>
  );

  if (linkTo) {
    return <Link to={linkTo}>{content}</Link>;
  }

  return content;
}
